import type { XmlNodeT } from './xml';

export type UserProfileT = {
  longTerm: string;
  shortTerm: string;
  userId: string;
};

export type XmlUserProfileV2 = XmlNodeT<'user-profile-v2'>;

export const NOTHING_IS_KNOWN_YET = 'Nothing is known yet.';

export const USER_PROFILE_DESCRIPTION = 'Our knowledge of the user, accumulated from our previous interactions with them.';

export const LONG_TERM_MEMORY_DESCRIPTION = 'Persistent user traits (e.g. the name, the gender, the date of birth), and other information that changes infrequently (e.g. user habits, tastes, recurrent preferences), and/or is relevant over long periods of time (months, and longer).';

export const SHORT_TERM_MEMORY_DESCRIPTION = 'Information relevant in the short term only (the last few days, up to the last few weeks, at most), e.g. the detailed memory of our last few interactions with them, the user\'s mood and state the last time we talked with them, recent user activities, etc.';

export function toXmlUserProfileV2(
  profile: Omit<UserProfileT, 'userId'> | null,
): XmlUserProfileV2 {
  const xml = `<user_profile description="${USER_PROFILE_DESCRIPTION}">
  <long_term_memory description="${LONG_TERM_MEMORY_DESCRIPTION}">
${profile?.longTerm ?? NOTHING_IS_KNOWN_YET}
  </long_term_memory>
  <short_term_memory description="${SHORT_TERM_MEMORY_DESCRIPTION}">
${profile?.shortTerm ?? NOTHING_IS_KNOWN_YET}
  </short_term_memory>
</user_profile>`;

  return { kind: 'user-profile-v2', xml };
}
